<template>
  <ContenPanel>
    <ContentWrapper class="content-block">
      <div class="company-block-container">
        <div v-if="props.company.imageUrl" class="logo-image">
          <img
            :src="`${props.company.imageUrl}/convert?cache=true&compress=true&quality=90&w=64&h=64`"
            :alt="props.company.name"
          />
        </div>

        <div class="text-container">
          <FhText variant="body-md" weight="bold" data-test-id="company-name">
            {{ props.company.name }}
          </FhText>

          <FhText
            v-if="props.company.url"
            variant="body-md"
            class="break-words"
            data-test-id="company-url"
          >
            {{ props.company.url }}
          </FhText>
        </div>
      </div>

      <div v-if="props.booking && props.booking.title" class="text-container">
        <FhText variant="body-md" weight="bold" data-test-id="booking-title">
          {{ props.booking.title }}
        </FhText>

        <FhText variant="body-md">
          {{ formatedBookingStartAtTZ }}
        </FhText>
      </div>
    </ContentWrapper>
  </ContenPanel>
</template>

<script setup>
import { computed } from 'vue';
import { FhText } from '@fareharbor-com/beacon-vue';
import ContenPanel from './ContentPanel.vue';
import ContentWrapper from './ContentWrapper.vue';
import { formatDate } from './utils';

const props = defineProps({
  booking: {
    type: Object,
    default: () => ({}),
  },
  company: {
    type: Object,
    default: () => ({}),
  },
});

const formatedBookingStartAtTZ = computed(() =>
  formatDate(props.booking.availabilityStartAtTz),
);
</script>

<style scoped>
.content-block {
  display: flex;
  flex-direction: column;
  gap: var(--fh-space-2xl);
}

.company-block-container {
  display: flex;
  align-items: center;
  gap: var(--fh-space-lg);
}

.text-container {
  display: flex;
  flex-direction: column;
  gap: var(--fh-space-xs);
}

.break-words {
  word-break: break-word;
}

.logo-image {
  display: flex;
  align-items: center;
  height: 64px;
  width: 64px;
}
</style>
